import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeDocumentNumberCommand extends BaseCommand {
  CommandName = "ChangeDocumentNumber";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
